var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',_vm._l((_setup.props.colors),function(color,index){return _c('li',{key:index,staticClass:"u-cursor-pointer",class:{'u-border-1 u-border-grey-2': _setup.isColorLight(color.hex)},style:(_setup.baubleStyle(color)),on:{"click":function($event){return _setup.onColorClicked(color)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }